// Fable+ paywall sheet: any API reply carrying a "paywall" block (Stage daily limit, guest preview end) opens this.
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Crown, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const SNOOZE_MS = 10 * 60 * 1000;
let lastShown = {};

export function PaywallSheet() {
  const [pw, setPw] = useState(null);
  useEffect(() => {
    const on = (e) => {
      const p = e.detail;
      if (!p || !p.reason) return;
      if (lastShown[p.reason] && Date.now() - lastShown[p.reason] < SNOOZE_MS) return;
      lastShown[p.reason] = Date.now();
      setPw(p);
    };
    window.addEventListener("fable:paywall", on);
    return () => window.removeEventListener("fable:paywall", on);
  }, []);
  if (!pw) return null;
  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] flex justify-center p-4 sm:bottom-6" role="dialog" aria-label={pw.title} data-testid="paywall-sheet">
      <div className="relative w-full max-w-md overflow-hidden rounded-3xl border border-border bg-background p-6 shadow-2xl">
        <div className="pointer-events-none absolute -right-16 -top-16 h-48 w-48 rounded-full bg-[#E0007A]/15 blur-2xl" />
        <button type="button" onClick={() => setPw(null)} aria-label="Close" className="absolute right-3 top-3 rounded-full p-1.5 text-muted-foreground hover:bg-muted"><X size={16} /></button>
        <span className="grid h-11 w-11 place-items-center rounded-2xl bg-gradient-to-br from-[#E0007A] to-[#8B3CF0] text-white"><Crown size={20} /></span>
        <h2 className="mt-3 text-xl font-bold">{pw.title}</h2>
        <p className="mt-1 text-sm text-muted-foreground">{pw.body}</p>
        <div className="mt-5 flex flex-col gap-2 sm:flex-row">
          <Link to={pw.url || "/membership"} onClick={() => setPw(null)} className="flex-1"><Button className="w-full rounded-full bg-[#E0007A] hover:bg-[#c4006a]" data-testid="paywall-cta">{pw.cta}{pw.price ? " · " + pw.price : ""}</Button></Link>
          {pw.secondary && <Link to={pw.secondary.url} onClick={() => setPw(null)} className="flex-1"><Button variant="outline" className="w-full rounded-full">{pw.secondary.label}</Button></Link>}
        </div>
        {pw.resets_at && <p className="mt-3 text-center text-xs text-muted-foreground">Free Stage resets at midnight.</p>}
      </div>
    </div>
  );
}
